module.exports = __webpack_public_path__ + "static/media/loading-screen.5a5d207f.jpg";